
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pilingReportPageQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pilingMachineList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PilingMachineTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pileByDateByPileMachineReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pileSummaryReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pilesMissingTableReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pileDuplicatesReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tableSummaryReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tableDuplicatesReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tablesMissingPilesReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tablesIncorrectPilesReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"consignmentReportPageQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consignmentList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"consignmentItemSummaryReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"consignmentItemsDuplicateReceiptsReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"consignmentItemsZeroReceiptsReport"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportTypeBase"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1055}};
    doc.loc.source = {"body":"#import \"../fragments/piling_machine_type_base_fragment\"\n#import \"../fragments/consignment_type_base_fragment\"\n#import \"../fragments/report_type_base_fragment\"\n#import \"../fragments/enums_type_base_fragment\"\n\nquery pilingReportPageQuery {\n  pilingMachineList {\n    ...PilingMachineTypeBase\n  }\n  pileByDateByPileMachineReport {\n    ...ReportTypeBase\n  }\n  pileSummaryReport {\n    ...ReportTypeBase\n  }\n  pilesMissingTableReport {\n    ...ReportTypeBase\n  }\n  pileDuplicatesReport {\n    ...ReportTypeBase\n  }\n  tableSummaryReport {\n    ...ReportTypeBase\n  }\n  # tableSummaryByZoneReport {\n  #   ...ReportTypeBase\n  # }\n  tableDuplicatesReport {\n    ...ReportTypeBase\n  }\n  tablesMissingPilesReport {\n    ...ReportTypeBase\n  }\n  tablesIncorrectPilesReport {\n    ...ReportTypeBase\n  }\n}\n\nquery consignmentReportPageQuery {\n  consignmentList {\n    id\n    name\n  }\n  consignmentItemSummaryReport {\n    ...ReportTypeBase\n  }\n  consignmentItemsDuplicateReceiptsReport {\n    ...ReportTypeBase\n  }\n  consignmentItemsZeroReceiptsReport {\n    ...ReportTypeBase\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/piling_machine_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/consignment_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/report_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/enums_type_base_fragment").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["pilingReportPageQuery"] = oneQuery(doc, "pilingReportPageQuery");
        
        module.exports["consignmentReportPageQuery"] = oneQuery(doc, "consignmentReportPageQuery");
        
